import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Menu } from "@headlessui/react";
import React, { Fragment, useEffect } from "react";
import SDropdownButton from "./SDropdownButton";
import { DropdownItem } from "./SDropdownItem";
import { SButton } from "../components";
const SDropdown = ({ title, ariaLabel, width = 200, elements, children, position = "right", style, className = "", wrapperClassName = "", display = "inline-block", isUnstyledItems = false, disabled = false, fixed = false, noWrap = true, buttonProps = {
    variant: "secondary",
    isMinimal: true,
    size: "lg"
} })=>{
    const widthStyle = !!width ? {
        width
    } : {
        minWidth: 150
    };
    const ref = React.useRef(null);
    const [offset, setOffset] = React.useState({
        top: 0,
        left: 0
    });
    const update = (ref)=>{
        if (ref.current) {
            setOffset({
                top: ref.current.getBoundingClientRect().bottom,
                left: ref.current.getBoundingClientRect().left
            });
        }
    };
    useEffect(()=>{
        if (typeof window === "undefined" || !fixed) return;
        const handleEvent = ()=>{
            if (ref.current) {
                setOffset({
                    top: ref.current.getBoundingClientRect().bottom,
                    left: ref.current.getBoundingClientRect().left
                });
            }
        };
        window.addEventListener("resize", handleEvent);
        window.addEventListener("scroll", handleEvent);
        return ()=>{
            window.removeEventListener("resize", handleEvent);
            window.removeEventListener("scroll", handleEvent);
        };
    }, [
        fixed
    ]);
    return /*#__PURE__*/ _jsx("div", {
        style: {
            display,
            ...style
        },
        className: wrapperClassName,
        children: /*#__PURE__*/ _jsxs(Menu, {
            as: "div",
            className: `relative flex-grow items-stretch ${disabled && "cursor-not-allowed"}`,
            children: [
                /*#__PURE__*/ _jsx(Menu.Button, {
                    as: "div",
                    onMouseEnter: ()=>{
                        update(ref);
                    },
                    onMouseMove: ()=>{
                        update(ref);
                    },
                    // @ts-ignore
                    ref: ref,
                    className: `h-full ${disabled ? "pointer-events-none" : ""}`,
                    style: {
                        WebkitAppearance: "unset"
                    },
                    children: children ?? /*#__PURE__*/ _jsx(SButton, {
                        "aria-label": ariaLabel,
                        ...buttonProps,
                        children: title
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx(Menu.Items, {
                        className: `
          ${fixed ? `fixed top-0 right-0` : `absolute ${position}-0 origin-top-${position}`}
          divide-y focus:outline-none z-[999] mt-1

          mr-[-1px]
          rounded-xl
          ${noWrap ? "whitespace-nowrap" : ""}
          divide-grayscale-dark
          border border-grayscale-darkest
          flex flex-col
          shadow-2xl
          shadow-grayscale-darkest
          bg-grayscale-light overflow-hidden ${className}`,
                        // TODO: measure the width of the target element
                        style: {
                            ...widthStyle,
                            ...fixed && ref.current ? {
                                top: ref.current?.getBoundingClientRect().bottom,
                                right: window.innerWidth - ref.current?.getBoundingClientRect().right
                            } : {}
                        },
                        children: elements.map((element, i)=>{
                            return /*#__PURE__*/ _jsx(Menu.Item, {
                                as: Fragment,
                                children: isUnstyledItems ? element : /*#__PURE__*/ _jsx(SDropdown.Item, {
                                    "aria-label": `${ariaLabel} - ${element}`,
                                    children: element
                                })
                            }, `dd-menu-${i}`);
                        })
                    })
                })
            ]
        })
    });
};
SDropdown.Item = DropdownItem;
SDropdown.Button = SDropdownButton;
export default SDropdown;
